import { useT } from "@transifex/react";
import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";
import DesignConstants from "../../../constants/DesignConstants";
import { OnboardingStep } from "../Onboarding";

import {
    OnboardingStepCircle,
    OnboardingStepContent,
    OnboardingStepDescription,
    OnboardingStepItemWrapper,
    OnboardingStepTitle,
} from "./StyledComponents";

interface OnboardingStepItemProps {
    step: OnboardingStep;
    onStepClick: () => void;
}

export const OnboardingStepItem = (props: OnboardingStepItemProps) => {
    const t = useT();

    const stepCompleted = t("Step completed", { _tags: "AssistantOverview" });
    const stepIncomplete = t("Step incomplete", { _tags: "AssistantOverview" });

    const stepStatusLabel = props.step.completed
        ? `${props.step.title} - ${stepCompleted}`
        : `${props.step.title} - ${stepIncomplete}`;

    return (
        <OnboardingStepItemWrapper
            completed={props.step.completed}
            onClick={props.onStepClick}
            disabled={props.step.completed}
            role="link"
            aria-label={stepStatusLabel}
            aria-disabled={props.step.completed}
        >
            <OnboardingStepCircle completed={props.step.completed}>
                {props.step.completed && (
                    <PhaseSixIcon
                        name="exercise-ok"
                        style={{ fontSize: DesignConstants.FONT_SIZES.XL, color: DesignConstants.COLORS.WHITE }}
                    />
                )}
            </OnboardingStepCircle>

            <OnboardingStepContent>
                <OnboardingStepTitle>{props.step.title}</OnboardingStepTitle>
                {props.step.description && (
                    <OnboardingStepDescription>{props.step.description}</OnboardingStepDescription>
                )}
            </OnboardingStepContent>

            <PhaseSixIcon
                name="chevron-right"
                style={{ fontSize: DesignConstants.FONT_SIZES.XL, color: DesignConstants.COLORS.DARK_GREY }}
            />
        </OnboardingStepItemWrapper>
    );
};
